import React, { useEffect, useState } from "react";
import "../../css_files/Quotation/QuotationPopup.css";
import CloseForm from "../Master/CloseForm";
import { toast, ToastContainer } from "react-toastify";
import axiosInstance from "../../api";
import Swal from "sweetalert2";
import LoadingScreen from "../Homepage/LoadingScreen";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";

function QuotationPopup() {
  const { quotationId } = useParams();
  const nav = useNavigate();
  const [quotationItemsData, setQuotationItemsData] = useState([]);
  const [partsIItemsData, setPartsItemData] = useState([]);
  const [procedureData, setProcedureData] = useState([]);
  const [commercialTerms, setCommercialTerms] = useState([]);
  const [quotationData, setQuotationData] = useState();
  const [gstPercentage, setgstPercentage] = useState(0);
  const [currencyData, setCurrencyData] = useState([]);
  const [copypartItemsdata, setcopypartItemsdata] = useState([]);
  const [currencyAbbr, setCurrencyAbbr] = useState("");
  const [INRrate, setINRRate] = useState("");
  const [itemsrefresh, setitemsrefresh] = useState(false);
  const [allparts, setAllParts] = useState([]);
  const [partpage, setpartpage] = useState(1);
  const [showaddpartform, setshowaddpartform] = useState(false);
  const [showaddserviceform, setshowaddserviceform] = useState(false);
  const [partsDropdown, setPartsDropdown] = useState([]);
  const partdataInitialState = {
    QuotationId: "",
    PartNumber: "",
    PartName: "",
    HSNCode: "",
    Quantity: "",
    Rate: "",
    Amount: "",
  };
  const [partdata, setpartdata] = useState(partdataInitialState);
  const [serviceData, setServiceData] = useState({
    QuotationId: "",
    Description: "",
    PricePerDay: "",
    NoOfDays: "",
    Total: "",
  });
  const [loading, setloading] = useState(false);
  const [showaddprocedures, setshowaddprocedures] = useState(false);
  const [showaddcommercialterms, setshowaddcommercialterms] = useState(false);
  const [commercialTermsdata, setCommercialTermsData] = useState({
    Title: "",
    Description: "",
  });
  const [procedureDescription, setProcedureDescription] = useState("");

  useEffect(() => {
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/Quotation/${encodeURIComponent(
          quotationId
        )}`
      )
      .then((res) => {
        setQuotationData(res.data);
        setgstPercentage(res.data?.gstPercentage);
        setCurrencyAbbr(res.data.symbol);
        if (res.data.enquiryType === "Parts") {
          axiosInstance
            .get(
              `${process.env.REACT_APP_API_URL}/api/PartItems/${res.data.id}`
            )
            .then((resp) => {
              setPartsItemData(resp.data);
              setcopypartItemsdata(resp.data);
            })
            .catch(console.log);
        } else {
          axiosInstance
            .get(
              `${process.env.REACT_APP_API_URL}/api/QuotationItems/${res.data.id}`
            )
            .then((resp) => {
              setQuotationItemsData(resp.data);
            })
            .catch(console.log);
        }

        if (res.data.enquiryType === "Service") {
          axiosInstance
            .get(
              `${process.env.REACT_APP_API_URL}/api/ProcedureDetails/${res.data.id}`
            )
            .then((resp) => {
              setProcedureData(resp.data);
            })
            .catch(console.log);
        }
        axiosInstance
          .get(
            `${process.env.REACT_APP_API_URL}/api/CommercialTerms/${res.data.id}`
          )
          .then((resp) => {
            setCommercialTerms(resp.data);
          })
          .catch(console.log);
      })
      .catch(console.log);
  }, [quotationId, itemsrefresh]);

  function calculateTotal() {
    if (quotationData?.enquiryType === "Parts") {
      return partsIItemsData
        .reduce((acc, curr) => acc + Number(curr.amount), 0.0)
        .toFixed(2);
    } else {
      return quotationItemsData
        .reduce((acc, curr) => acc + Number(curr.total), 0.0)
        .toFixed(2);
    }
  }

  function rateLogic(rate1, currency) {
    const rate = Math.round(rate1);
    let adjustby = 0;
    if (rate === 0) {
      return 0;
    }
    if (currency === "INR") {
      const last2Digits = rate % 100;

      if (last2Digits <= 50) {
        adjustby = 50 - last2Digits;
        const newRate = rate + adjustby;
        return newRate;
      } else {
        adjustby = 100 - last2Digits;
        const newRate = rate + adjustby;
        return newRate;
      }
    }
    return rate1;
  }

  useEffect(() => {
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/Currency/GetCurrencyDropdown`
      )
      .then((res) => {
        setCurrencyData(res.data);
      })
      .catch(console.log);
  }, []);

  useEffect(() => {
    currencyData.forEach((x) => {
      if (quotationData?.symbol === x.code) {
        setINRRate(x.rate);
      }
    });
  }, [quotationData?.symbol, currencyData]);

  function getAllParts() {
    setshowaddpartform(true);

    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/api/v1/Parts/GetAllPartsDropdown`)
      .then((res) => {
        setPartsDropdown(res.data);
      })
      .catch(console.log);
  }

  useEffect(() => {
    const discountAmount = Number(
      Number(calculateTotal()) *
        (Number(quotationData?.discountPercentage || "0") / 100)
    ).toFixed(2);
    const gstAmount = Number(
      (Number(calculateTotal()) +
        Number(quotationData?.packingForwarding || "0") +
        Number(quotationData?.courierExp || "0") -
        discountAmount) *
        (Number(gstPercentage) / 100)
    ).toFixed(2);

    const finalTotal = Number(
      Number(calculateTotal()) +
        Number(quotationData?.packingForwarding || "0") +
        Number(quotationData?.courierExp || "0") -
        Number(discountAmount)
    ).toFixed(2);

    const grandTotal = Number(Number(finalTotal) + Number(gstAmount)).toFixed(
      2
    );

    setQuotationData({
      ...quotationData,
      finalTotal,
      grandTotal,
      gstAmount,
      discountAmount,
    });
  }, [
    quotationItemsData,
    partsIItemsData,
    quotationData?.enquiryType,
    quotationData?.discountPercentage,
    quotationData?.packingForwarding,
    quotationData?.courierExp,
    gstPercentage,
  ]);

  return (
    <section className="quotation-popup">
      <div>
        <i
          className="fa-solid fa-arrow-left fa-2x"
          style={{ float: "inline-end", cursor: "pointer" }}
          onClick={() => nav(-1)}
        ></i>
        <h2>Quotation Items</h2>
        {quotationData?.enquiryType === "Service" ? (
          <div>
            <table>
              <thead>
                <tr>
                  <th>Sr.No.</th>
                  <th>Service Description</th>
                  <th>Price Per Day</th>
                  <th>Number of Days</th>
                  <th>Total</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {quotationItemsData.map((x, id) => (
                  <tr>
                    <td>{id + 1}</td>
                    <td>
                      <input
                        type="text"
                        placeholder="Enter Service Description"
                        value={x.description}
                        onChange={(e) =>
                          setQuotationItemsData((prev) =>
                            prev.map((item, i) =>
                              i === id
                                ? { ...item, description: e.target.value }
                                : item
                            )
                          )
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        onInput={(e) => {
                          e.target.value = e.target.value
                            .replace(/[^0-9.]/g, "")
                            .replace(/(\..*)\./g, "$1")
                            .replace(/^(\d*\.\d{2}).*$/, "$1");
                        }}
                        placeholder="Enter Price Per Day"
                        value={x.pricePerDay}
                        onChange={(e) => {
                          setQuotationItemsData((prev) =>
                            prev.map((item, i) =>
                              i === id
                                ? {
                                    ...item,
                                    pricePerDay: e.target.value,
                                    total: Number(
                                      Number(e.target.value || "0") *
                                        Number(item.noOfDays || "0")
                                    ).toFixed(2),
                                  }
                                : item
                            )
                          );
                        }}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        placeholder="Enter Number of Days"
                        value={x.noOfDays}
                        onChange={(e) =>
                          setQuotationItemsData((prev) =>
                            prev.map((item, i) =>
                              i === id
                                ? {
                                    ...item,
                                    noOfDays: e.target.value,
                                    total: Number(
                                      Number(item.pricePerDay || "0") *
                                        Number(e.target.value || "0")
                                    ).toFixed(2),
                                  }
                                : item
                            )
                          )
                        }
                      />
                    </td>
                    <td>
                      {currencyAbbr} {x.total}
                    </td>
                    <td
                      onClick={() => {
                        Swal.fire({
                          icon: "error",
                          titleText: "Are You Sure?",
                          text: "This Service Item Will get deleted",
                          showConfirmButton: true,
                          showCancelButton: true,
                        }).then((result) => {
                          if (result.isConfirmed) {
                            axiosInstance
                              .put(
                                `${process.env.REACT_APP_API_URL}/api/v1/Quotation`,
                                {
                                  SeriesId: quotationId,
                                  DiscountPercentage:
                                    quotationData.discountPercentage,
                                  DiscountValue: quotationData.discountAmount,
                                  SubTotal: calculateTotal(),
                                  FinalTotal: quotationData.finalTotal,
                                  GSTAmount: quotationData.gstAmount,
                                  GrandTotal: quotationData.grandTotal,
                                  Symbol: currencyAbbr,
                                  PackingForwarding:
                                    quotationData.packingForwarding,
                                  CourierExp: quotationData.courierExp,
                                }
                              )
                              .then((res) => {
                                axiosInstance
                                  .delete(
                                    `${process.env.REACT_APP_API_URL}/api/QuotationItems/DeleteQuotationItemById/${x.id}`
                                  )
                                  .then((res) => {
                                    toast.success(res.data, {
                                      position: "bottom-center",
                                      theme: "dark",
                                    });
                                    setitemsrefresh(!itemsrefresh);
                                  })
                                  .catch(console.log);
                              })
                              .catch(console.log);
                          }
                        });
                      }}
                    >
                      <i className="fa-solid fa-trash"></i>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <form>
              <blockquote>
                <label>Discount Percentage:</label>
                <input
                  type="number"
                  onInput={(e) => (e.target.value = e.target.value.slice(0, 2))}
                  placeholder="Enter Discount in Percentage (Press Enter Key)"
                  onChange={(e) => {
                    setQuotationData({
                      ...quotationData,
                      discountPercentage: e.target.value,
                    });
                  }}
                  value={quotationData?.discountPercentage}
                />
              </blockquote>
            </form>
          </div>
        ) : (
          <div>
            <table>
              <thead>
                <tr>
                  <th>Sr.No.</th>
                  <th>Part Number</th>
                  <th>Part Name</th>
                  <th>HSN Code</th>
                  <th>Price Per Part</th>
                  <th>Quantity</th>
                  <th>Total Amount</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {partsIItemsData.map((x, i) => (
                  <tr>
                    <td>{i + 1}</td>
                    <td>{x.partNumber}</td>
                    <td>{x.partName}</td>
                    <td>{x.hsnCode}</td>
                    <td>
                      <input
                        type="text"
                        onInput={(e) => {
                          e.target.value = e.target.value
                            .replace(/[^0-9.]/g, "")
                            .replace(/(\..*)\./g, "$1")
                            .replace(/^(\d*\.\d{2}).*$/, "$1");
                        }}
                        placeholder="Enter Price Per Part"
                        value={x.rate}
                        onChange={(e) =>
                          setPartsItemData((prev) =>
                            prev.map((x, j) =>
                              j === i
                                ? {
                                    ...x,
                                    rate: e.target.value,
                                    amount: Number(
                                      Number(x.quantity || 0) *
                                        Number(e.target.value || 0)
                                    ).toFixed(2),
                                  }
                                : x
                            )
                          )
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        placeholder="Enter Quantity"
                        value={x.quantity}
                        onInput={(e) =>
                          (e.target.value = e.target.value.slice(0, 9))
                        }
                        onChange={(e) =>
                          setPartsItemData((prev) =>
                            prev.map((x, j) =>
                              j === i
                                ? {
                                    ...x,
                                    quantity: e.target.value,
                                    amount: Number(
                                      Number(x.rate || 0) *
                                        Number(e.target.value || 0)
                                    ).toFixed(2),
                                  }
                                : x
                            )
                          )
                        }
                      />
                    </td>
                    <td>
                      {currencyAbbr} {x.amount}
                    </td>
                    <td
                      onClick={() => {
                        Swal.fire({
                          icon: "error",
                          title: "Are You Sure?",
                          text: "This Part Item Will Get Deleted From This Quotaion.",
                          showConfirmButton: true,
                          showCancelButton: true,
                        }).then((result) => {
                          if (result.isConfirmed) {
                            axiosInstance
                              .put(
                                `${process.env.REACT_APP_API_URL}/api/v1/Quotation`,
                                {
                                  SeriesId: quotationId,
                                  DiscountPercentage:
                                    quotationData.discountPercentage,
                                  DiscountValue: quotationData.discountAmount,
                                  SubTotal: calculateTotal(),
                                  FinalTotal: quotationData.finalTotal,
                                  GSTAmount: quotationData.gstAmount,
                                  GrandTotal: quotationData.grandTotal,
                                  Symbol: currencyAbbr || quotationData.symbol,
                                  PackingForwarding:
                                    quotationData.packingForwarding,
                                  CourierExp: quotationData.courierExp,
                                }
                              )
                              .then((res) => {
                                axiosInstance
                                  .delete(
                                    `${process.env.REACT_APP_API_URL}/api/PartItems/DeletePartItemsById/${x.id}`
                                  )
                                  .then((res) => {
                                    toast.success(res.data, {
                                      position: "bottom-center",
                                      theme: "dark",
                                    });
                                    setitemsrefresh(!itemsrefresh);
                                  })
                                  .catch(console.log);
                              })
                              .catch(console.log);
                          }
                        });
                      }}
                    >
                      <i className="fa-solid fa-trash"></i>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <form id="quotation_popup_discount_courier_packing_edit">
              <blockquote>
                <label>Discount Percentage:</label>
                <input
                  type="number"
                  required
                  value={quotationData?.discountPercentage}
                  onInput={(e) => (e.target.value = e.target.value.slice(0, 2))}
                  placeholder="Enter Discount in Percentage"
                  onChange={(e) => {
                    setQuotationData({
                      ...quotationData,
                      discountPercentage: e.target.value,
                    });
                  }}
                />
              </blockquote>
              <blockquote>
                <label>Packing and Forwarding</label>
                <input
                  type="text"
                  required
                  placeholder="Enter Packaging and Forwarding Charges"
                  onInput={(e) => {
                    e.target.value = e.target.value
                      .replace(/[^0-9.]/g, "")
                      .replace(/(\..*)\./g, "$1")
                      .replace(/^(\d*\.\d{2}).*$/, "$1");
                  }}
                  onChange={(e) => {
                    setQuotationData({
                      ...quotationData,
                      packingForwarding: e.target.value,
                    });
                  }}
                  value={quotationData?.packingForwarding}
                />
              </blockquote>
              <blockquote>
                <label>Transport/Courier Charges</label>
                <input
                  type="text"
                  required
                  placeholder="Enter Transport/Courier Charges"
                  onInput={(e) => {
                    e.target.value = e.target.value
                      .replace(/[^0-9.]/g, "")
                      .replace(/(\..*)\./g, "$1")
                      .replace(/^(\d*\.\d{2}).*$/, "$1");
                  }}
                  onChange={(e) => {
                    setQuotationData({
                      ...quotationData,
                      courierExp: e.target.value,
                    });
                  }}
                  value={quotationData?.courierExp}
                />
              </blockquote>
              <blockquote>
                <label>Currency</label>
                <select
                  required
                  onChange={(e) => {
                    setPartsItemData(copypartItemsdata);

                    if (e.target.value === "") {
                      setCurrencyAbbr("");
                    } else {
                      const rateCode = e.target.value.split(" ");
                      setPartsItemData((prev) =>
                        prev.map((x) => {
                          const rate = Number(
                            Number(INRrate * x.rate) / Number(rateCode[0])
                          ).toFixed(2);
                          return {
                            ...x,
                            rate,
                            amount: Number(
                              rate * Number(x.quantity || 0)
                            ).toFixed(2),
                          };
                        })
                      );

                      setCurrencyAbbr(rateCode[1]);
                      if (rateCode[1] === "INR") {
                        setgstPercentage(18);
                      } else {
                        setgstPercentage(0);
                      }
                      setQuotationData({
                        ...quotationData,
                        packingForwarding: Number(
                          (Number(INRrate) *
                            Number(quotationData.packingForwarding)) /
                            Number(rateCode[0])
                        ).toFixed(2),
                        courierExp: Number(
                          (Number(INRrate) * Number(quotationData.courierExp)) /
                            Number(rateCode[0])
                        ).toFixed(2),
                      });
                    }
                  }}
                >
                  <option value="">Select Currency</option>
                  {currencyData.map((x) => (
                    <option
                      value={`${x.rate} ${x.code}`}
                      selected={currencyAbbr === x.code}
                    >{`${x.label} (${x.code})`}</option>
                  ))}
                </select>
              </blockquote>
            </form>
          </div>
        )}
        <div>
          {showaddpartform && (
            <form
              onSubmit={(e) => {
                e.preventDefault();

                if (
                  partsIItemsData.some(
                    (x) => x.partNumber === partdata.PartNumber
                  )
                ) {
                  toast.error("Part Item Already Exists", {
                    position: "bottom-center",
                    theme: "dark",
                  });
                  return;
                }
                setloading(true);

                axiosInstance
                  .put(`${process.env.REACT_APP_API_URL}/api/v1/Quotation`, {
                    SeriesId: quotationId,
                    DiscountPercentage: quotationData.discountPercentage,
                    DiscountValue: quotationData.discountAmount,
                    SubTotal: calculateTotal(),
                    FinalTotal: quotationData.finalTotal,
                    GSTAmount: quotationData.gstAmount,
                    GrandTotal: quotationData.grandTotal,
                    Symbol: currencyAbbr,
                    PackingForwarding: quotationData.packingForwarding,
                    CourierExp: quotationData.courierExp,
                  })
                  .then((res) => {
                    axiosInstance
                      .post(
                        `${process.env.REACT_APP_API_URL}/api/PartItems`,
                        partdata
                      )
                      .then((res) => {
                        toast.success("Successfully Added Part Item", {
                          position: "bottom-center",
                          theme: "dark",
                        });

                        setitemsrefresh(!itemsrefresh);
                        setshowaddpartform(false);
                        setpartdata(partdataInitialState);
                        setloading(false);
                      })
                      .catch(console.log);
                  })
                  .catch(console.log);
              }}
            >
              <blockquote>
                <label>Select Part Name</label>
                <Select
                  isSearchable
                  options={partsDropdown}
                  onChange={(values) => {
                    if (values) {
                      const val = values?.value;
                      axiosInstance
                        .get(
                          `${process.env.REACT_APP_API_URL}/api/v1/Parts/GetPartsByIdAndName?id=${val}&page=1`
                        )
                        .then((res) => {
                          const sellingPrice =
                            Number(res.data?.data[0]?.sellingPrice || 0) +
                            Number(res.data?.data[0]?.sellingPrice || 0) *
                              (Number(
                                quotationData?.customer?.pricing?.percentage
                              ) /
                                100);

                          setpartdata({
                            QuotationId: quotationData.id,
                            PartNumber: res.data?.data[0]?.partNumber,
                            PartName: res.data?.data[0]?.name,
                            HSNCode: res.data?.data[0]?.hsn?.hsnCode,
                            Rate: rateLogic(sellingPrice, currencyAbbr),
                            Amount: partdata.Quantity
                              ? rateLogic(sellingPrice, currencyAbbr)
                              : "0",
                            Quantity: "",
                          });
                        })
                        .catch((err) => {
                          setpartdata(partdataInitialState);
                        });
                    }
                  }}
                  placeholder="Select Part Name"
                  isClearable
                  required
                  styles={{
                    container: (base) => ({
                      ...base,
                      width: "100%",
                    }),
                    placeholder: (base) => ({
                      ...base,
                      color: "black",
                    }),
                    control: (base, state) => ({
                      ...base,
                      borderColor: "black",
                      "&:hover": {
                        borderColor: "black",
                      },
                      boxShadow: "none",
                    }),
                    singleValue: (base) => ({
                      ...base,
                      color: "black",
                    }),
                    dropdownIndicator: (base) => ({
                      ...base,
                      color: "black",
                      "&:hover": {
                        color: "black",
                      },
                    }),
                    indicatorSeparator: (base) => ({
                      ...base,
                      backgroundColor: "black",
                    }),
                    noOptionsMessage: (base) => ({
                      ...base,
                      color: "black",
                    }),
                  }}
                />
              </blockquote>
              <blockquote>
                <label>Part Number</label>
                <input readOnly value={partdata.PartNumber} type="text" />
              </blockquote>
              <blockquote>
                <label>HSN Code</label>
                <input type="text" readOnly value={partdata.HSNCode} />
              </blockquote>
              <blockquote>
                <label>Price Per Part</label>
                <input
                  type="text"
                  value={partdata.Rate}
                  required
                  onInput={(e) => {
                    e.target.value = e.target.value
                      .replace(/[^0-9.]/g, "")
                      .replace(/(\..*)\./g, "$1")
                      .replace(/^(\d*\.\d{2}).*$/, "$1");
                  }}
                  onChange={(e) => {
                    setpartdata({
                      ...partdata,
                      Rate: e.target.value,
                      Amount: Number(
                        Number(e.target.value || 0) *
                          Number(partdata.Quantity || 0)
                      ).toFixed(2),
                    });
                  }}
                />
              </blockquote>
              <blockquote>
                <label>Quantity</label>
                <input
                  type="number"
                  required
                  value={partdata.Quantity}
                  onChange={(e) => {
                    setpartdata({
                      ...partdata,
                      Quantity: e.target.value,
                      Amount: Number(
                        Number(e.target.value || 0) * Number(partdata.Rate || 0)
                      ).toFixed(2),
                    });
                  }}
                />
              </blockquote>
              <blockquote>
                <label>Total Amount</label>
                <input type="number" readOnly value={partdata.Amount} />
              </blockquote>
              <button type="submit">Submit</button>
              {loading && <LoadingScreen />}
            </form>
          )}
          {showaddserviceform && (
            <form
              onSubmit={(e) => {
                e.preventDefault();
                setloading(true);
                axiosInstance
                  .put(`${process.env.REACT_APP_API_URL}/api/v1/Quotation`, {
                    SeriesId: quotationId,
                    DiscountPercentage: quotationData.discountPercentage,
                    DiscountValue: quotationData.discountAmount,
                    SubTotal: calculateTotal(),
                    FinalTotal: quotationData.finalTotal,
                    GSTAmount: quotationData.gstAmount,
                    GrandTotal: quotationData.grandTotal,
                    Symbol: currencyAbbr,
                    PackingForwarding: quotationData.packingForwarding,
                    CourierExp: quotationData.courierExp,
                  })
                  .then((res) => {
                    axiosInstance
                      .post(
                        `${process.env.REACT_APP_API_URL}/api/QuotationItems/AddQuotationItems`,
                        { ...serviceData, QuotationId: quotationData.id }
                      )
                      .then((res) => {
                        toast.success(res.data, {
                          position: "bottom-center",
                          theme: "dark",
                        });
                        setloading(false);
                        setshowaddserviceform(false);
                        setitemsrefresh(!itemsrefresh);
                      })
                      .catch(console.log);
                  })
                  .catch(console.log);
              }}
            >
              <blockquote>
                <label>Description</label>
                <input
                  type="text"
                  placeholder="Enter Service Description"
                  onChange={(e) => {
                    setServiceData({
                      ...serviceData,
                      Description: e.target.value,
                    });
                  }}
                  onInput={(e) => {
                    e.target.value = e.target.value.slice(0, 400);
                  }}
                  value={serviceData.Description}
                  required
                />
              </blockquote>
              <blockquote>
                <label>Price Per Day</label>
                <input
                  type="text"
                  onInput={(e) => {
                    e.target.value = e.target.value
                      .replace(/[^0-9.]/g, "")
                      .replace(/(\..*)\./g, "$1")
                      .replace(/^(\d*\.\d{2}).*$/, "$1");
                  }}
                  required
                  placeholder="Enter Price Per Day"
                  onChange={(e) => {
                    setServiceData({
                      ...serviceData,
                      PricePerDay: e.target.value,
                      Total: Number(
                        Number(e.target.value || 0) *
                          Number(serviceData.NoOfDays || 0)
                      ).toFixed(2),
                    });
                  }}
                  value={serviceData.PricePerDay}
                />
              </blockquote>
              <blockquote>
                <label>Number of Days</label>
                <input
                  type="number"
                  required
                  placeholder="Enter Number of Days"
                  onInput={(e) => {
                    e.target.value = e.target.value.slice(0, 5);
                  }}
                  onChange={(e) => {
                    setServiceData({
                      ...serviceData,
                      NoOfDays: e.target.value,
                      Total: Number(
                        Number(e.target.value || 0) *
                          Number(serviceData.PricePerDay || 0)
                      ).toFixed(2),
                    });
                  }}
                  value={serviceData.NoOfDays}
                />
              </blockquote>
              <blockquote>
                <label>Total</label>
                <input
                  type="text"
                  readOnly
                  value={serviceData.Total}
                  required
                />
              </blockquote>
              <button type="submit">Submit</button>
              {loading && <LoadingScreen />}
            </form>
          )}
        </div>
        <button
          onClick={() => {
            const formref = document.getElementById(
              "quotation_popup_discount_courier_packing_edit"
            );
            if (formref && !formref.checkValidity()) {
              formref.reportValidity();
              return;
            }
            axiosInstance
              .put(`${process.env.REACT_APP_API_URL}/api/v1/Quotation`, {
                SeriesId: quotationId,
                DiscountPercentage: quotationData.discountPercentage,
                DiscountValue: quotationData.discountAmount,
                SubTotal: calculateTotal(),
                FinalTotal: quotationData.finalTotal,
                GSTAmount: quotationData.gstAmount,
                GrandTotal: quotationData.grandTotal,
                Symbol: currencyAbbr,
                PackingForwarding: quotationData.packingForwarding,
                CourierExp: quotationData.courierExp,
              })
              .then((res) => {
                toast.success(res.data, {
                  position: "bottom-center",
                  theme: "dark",
                });
              })
              .catch((err) => {
                console.log(err);
                toast.error("Failed to Update Quotation", {
                  position: "bottom-center",
                  theme: "dark",
                });
              });

            if (quotationData.enquiryType === "Parts") {
              Promise.all(
                partsIItemsData.map((x) =>
                  axiosInstance
                    .put(`${process.env.REACT_APP_API_URL}/api/PartItems`, {
                      Id: x.id,
                      Quantity: x.quantity || 0,
                      Amount: x.amount || 0,
                      Rate: x.rate || 0,
                    })
                    .then((res) => "")
                    .catch((err) => "")
                )
              ).then((res) => {
                toast.success("Updated Successfully", {
                  position: "bottom-center",
                  theme: "dark",
                });
              });
            } else {
              Promise.all(
                quotationItemsData.map((x) =>
                  axiosInstance
                    .put(
                      `${process.env.REACT_APP_API_URL}/api/QuotationItems`,
                      {
                        Id: x.id,
                        Description: x.description,
                        PricePerDay: x.pricePerDay || 0,
                        NoOfDays: x.noOfDays || 0,
                        Total: x.total || 0,
                      }
                    )
                    .then((res) => "")
                    .catch((err) => "")
                )
              ).then((res) => {
                toast.success("Updated Successfully", {
                  position: "bottom-center",
                  theme: "dark",
                });
              });
            }
          }}
        >
          Update
        </button>{" "}
        <button
          onClick={() => {
            if (quotationData.enquiryType === "Parts") getAllParts();
            else setshowaddserviceform(true);
          }}
        >
          Add
        </button>
        <dl>
          <dt>Subtotal</dt>
          <dd>
            {currencyAbbr} {calculateTotal()}
          </dd>

          {quotationData?.enquiryType === "Parts" && (
            <>
              <dt>Packing & Forwarding-Sales</dt>
              <dd>
                {currencyAbbr} {quotationData?.packingForwarding}
              </dd>
              <dt>Courier Exp-Sales</dt>
              <dd>
                {currencyAbbr} {quotationData?.courierExp}
              </dd>
            </>
          )}
          <dt>Discount ({quotationData?.discountPercentage}%)</dt>
          <dd>
            {currencyAbbr} {quotationData?.discountAmount}
          </dd>
          <dt>Final Total</dt>
          <dd>
            {currencyAbbr} {quotationData?.finalTotal}
          </dd>
          {gstPercentage !== 0 && (
            <>
              <dt>GST: ({gstPercentage}%)</dt>
              <dd>
                {currencyAbbr} {quotationData?.gstAmount}
              </dd>
            </>
          )}
          <dt>Grand Total</dt>
          <dd>
            {currencyAbbr} {quotationData?.grandTotal}
          </dd>
        </dl>
      </div>
      {quotationData?.enquiryType === "Service" && (
        <div>
          <h2>Procedures</h2>
          <table>
            <thead>
              <tr>
                <th>Sr.No.</th>
                <th>Description</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {procedureData.map((x, id) => (
                <tr>
                  <td style={{ width: "2rem" }}>{id + 1}</td>
                  <td>
                    <input
                      type="text"
                      placeholder="Enter Description"
                      value={x.description}
                      onChange={(e) =>
                        setProcedureData((prev) =>
                          prev.map((item, i) =>
                            i === id
                              ? { ...item, description: e.target.value }
                              : item
                          )
                        )
                      }
                    />
                  </td>
                  <td
                    style={{ width: "2rem" }}
                    onClick={() => {
                      Swal.fire({
                        icon: "error",
                        title: "Are you Sure?",
                        text: "This Procedure Will Get Removed",
                        showConfirmButton: true,
                        showCancelButton: true,
                      }).then((result) => {
                        if (result.isConfirmed) {
                          axiosInstance
                            .delete(
                              `${process.env.REACT_APP_API_URL}/api/ProcedureDetails/DeleteProcedureById/${x.id}`
                            )
                            .then((res) => {
                              toast.success(res.data, {
                                position: "bottom-center",
                                theme: "dark",
                              });
                              setitemsrefresh(!itemsrefresh);
                            })
                            .catch(console.log);
                        }
                      });
                    }}
                  >
                    <i className="fa-solid fa-trash"></i>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <button
            onClick={() => {
              Promise.all(
                procedureData.map((x) =>
                  axiosInstance
                    .put(
                      `${process.env.REACT_APP_API_URL}/api/ProcedureDetails`,
                      {
                        Id: x.id,
                        Description: x.description,
                      }
                    )
                    .then((res) => "")
                    .catch((err) => "")
                )
              ).then((res) => {
                toast.success("Updated Successfully", {
                  position: "bottom-center",
                  theme: "dark",
                });
              });
            }}
          >
            Update
          </button>{" "}
          <button
            onClick={() => {
              if (procedureData.length >= 10)
                toast.warning(
                  "Maximum Limit to Add Procedures Reached. Please Delete Some to Add More",
                  {
                    position: "bottom-center",
                    theme: "dark",
                  }
                );
              else setshowaddprocedures(true);
            }}
          >
            Add
          </button>
          {showaddprocedures && (
            <form
              onSubmit={(e) => {
                e.preventDefault();
                setloading(true);
                axiosInstance
                  .post(
                    `${process.env.REACT_APP_API_URL}/api/ProcedureDetails/AddProcedure`,
                    {
                      QuotationId: quotationData.id,
                      Description: procedureDescription,
                    }
                  )
                  .then((res) => {
                    toast.success(res.data, {
                      position: "bottom-center",
                      theme: "dark",
                    });
                    setloading(false);
                    setitemsrefresh(!itemsrefresh);
                    setshowaddprocedures(false);
                  })
                  .catch(console.log);
              }}
            >
              <blockquote style={{ gridColumn: "span 3" }}>
                <label>Description</label>
                <textarea
                  rows={2}
                  placeholder="Enter Description (Maximum 400 Characters)"
                  onInput={(e) => {
                    e.target.value = e.target.value.slice(0, 400);
                  }}
                  onChange={(e) => {
                    setProcedureDescription(e.target.value);
                  }}
                  required
                ></textarea>
              </blockquote>
              <button type="submit">Submit</button>
              {loading && <LoadingScreen />}
            </form>
          )}
        </div>
      )}
      <div>
        <h2>Commercial Terms</h2>
        <table>
          <thead>
            <tr>
              <th>
                <center>Sr.No.</center>
              </th>
              <th>
                <center>Title</center>
              </th>
              <th>
                <center>Description</center>
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {commercialTerms.map((x, id) => (
              <tr>
                <td>
                  <center>{id + 1}</center>
                </td>
                <td>
                  <input
                    type="text"
                    placeholder="Enter Title"
                    value={x.title}
                    onChange={(e) =>
                      setCommercialTerms((prev) =>
                        prev.map((item, i) =>
                          i === id ? { ...item, title: e.target.value } : item
                        )
                      )
                    }
                  />
                </td>
                <td>
                  <input
                    type="text"
                    placeholder="Enter Description"
                    value={x.description}
                    onChange={(e) =>
                      setCommercialTerms((prev) =>
                        prev.map((item, i) =>
                          i === id
                            ? { ...item, description: e.target.value }
                            : item
                        )
                      )
                    }
                  />
                </td>
                <td
                  onClick={() => {
                    Swal.fire({
                      icon: "error",
                      title: "Are You Sure?",
                      text: "This Commercial Term will get removed",
                      showConfirmButton: true,
                      showCancelButton: true,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        axiosInstance
                          .delete(
                            `${process.env.REACT_APP_API_URL}/api/CommercialTerms/DeleteCommercialTermsById/${x.id}`
                          )
                          .then((res) => {
                            toast.success(res.data, {
                              position: "bottom-center",
                              theme: "dark",
                            });
                            setitemsrefresh(!itemsrefresh);
                          })
                          .catch(console.log);
                      }
                    });
                  }}
                >
                  <i className="fa-solid fa-trash"></i>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <button
          onClick={() => {
            Promise.all(
              commercialTerms.map((x) =>
                axiosInstance
                  .put(`${process.env.REACT_APP_API_URL}/api/CommercialTerms`, {
                    Id: x.id,
                    Title: x.title,
                    Description: x.description,
                  })
                  .then((res) => "")
                  .catch((err) => "")
              )
            ).then((res) => {
              toast.success("Updated Successfully", {
                position: "bottom-center",
                theme: "dark",
              });
            });
          }}
        >
          Update
        </button>{" "}
        <button
          onClick={() => {
            if (commercialTerms.length >= 10) {
              toast.warning(
                "Maximum limit to add commercial terms reached. please delete some to add",
                {
                  position: "bottom-center",
                  theme: "dark",
                }
              );
            } else {
              setshowaddcommercialterms(true);
            }
          }}
        >
          Add
        </button>
        {showaddcommercialterms && (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              setloading(true);
              axiosInstance
                .post(
                  `${process.env.REACT_APP_API_URL}/api/CommercialTerms/AddCommercialTerms`,
                  {
                    QuotationId: quotationData.id,
                    Title: commercialTermsdata.Title,
                    Description: commercialTermsdata.Description,
                  }
                )
                .then((res) => {
                  toast.success(res.data, {
                    position: "bottom-center",
                    theme: "dark",
                  });
                  setloading(false);
                  setitemsrefresh(!itemsrefresh);
                  setshowaddcommercialterms(false);
                })
                .catch(console.log);
            }}
          >
            <blockquote>
              <label>Title</label>
              <input
                type="text"
                placeholder="Add Title"
                onInput={(e) => {
                  e.target.value = e.target.value.slice(0, 200);
                }}
                onChange={(e) =>
                  setCommercialTermsData({
                    ...commercialTermsdata,
                    Title: e.target.value,
                  })
                }
                required
              />
            </blockquote>
            <blockquote style={{ gridColumn: "span 2" }}>
              <label>Description</label>
              <input
                type="text"
                placeholder="Add Description"
                onInput={(e) => {
                  e.target.value = e.target.value.slice(0, 400);
                }}
                onChange={(e) =>
                  setCommercialTermsData({
                    ...commercialTermsdata,
                    Description: e.target.value,
                  })
                }
                required
              />
            </blockquote>
            <button type="submit">Submit</button>
            {loading && <LoadingScreen />}
          </form>
        )}
      </div>
    </section>
  );
}

export default QuotationPopup;
